/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import ReactDOM from 'react-dom';
import './PageBase.css';
import { Footer } from '../Footer';
import { MyUser } from '../MyUser';
import { SideBar } from '../SideBar';
import { TopBar } from '../TopBar';


function PageBase({ children }) {
    const [isLeftMenuOpen, setIsLeftMenuOpen] = useState(false);
    const [isRightMenuOpen, setIsRightMenuOpen] = useState(false);

    const toggleLeftMenu = () => {
        setIsLeftMenuOpen(!isLeftMenuOpen);
        setIsRightMenuOpen(false);
    };

    const toggleRightMenu = () => {
        setIsRightMenuOpen(!isRightMenuOpen);
        setIsLeftMenuOpen(false);
    };

    const portalRoot = document.getElementById('portal-root');

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);


        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const closeMenusOnOutsideClick = (event) => {
            if (isLeftMenuOpen || isRightMenuOpen) {
                const clickedElement = event.target;
                const footerElement = document.querySelector('.footer');
                const sideBarElement = document.querySelector('.side-menu-movil');

                if (
                    !footerElement.contains(clickedElement) &&
                    !sideBarElement.contains(clickedElement)
                ) {
                    setIsLeftMenuOpen(false);
                    setIsRightMenuOpen(false);
                }
            }
        };

        document.addEventListener('click', closeMenusOnOutsideClick);

        return () => {
            document.removeEventListener('click', closeMenusOnOutsideClick);
        };
    }, [isLeftMenuOpen, isRightMenuOpen]);

    return ReactDOM.createPortal(
        <>
            {children}
            <div className="web">
                <TopBar />
                <SideBar />
            </div>
            {windowWidth < 780 ? (
                <div className="movil">
                    <TopBar />
                    <SideBar isLeftMenuOpen={isLeftMenuOpen} />
                    <MyUser isRightMenuOpen={isRightMenuOpen} />
                    <Footer
                        isLeftMenuOpen={isLeftMenuOpen}
                        isRightMenuOpen={isRightMenuOpen}
                        toggleLeftMenu={toggleLeftMenu}
                        toggleRightMenu={toggleRightMenu} />
                </div>
            ) : null}
        </>, portalRoot
    )
}

export { PageBase }